import React from 'react';
import { Route, Routes, useParams } from "react-router-dom";
import { Container } from 'react-bootstrap';

import LeftNav from '../../components/LeftNav';
import GuardrailList from './GuardrailList';
import GuardrailDetail from './GuardrailDetail';
import GuardrailForm from './GuardrailForm';
/*
import GuardrailLog from './GuardrailLog';

*/

//selection is useful if guardrails is own stand alone section outside of analytics
//could have standalone section for creating them, then a section within the analytics for the logs
//need to separate logs (analytics) from the alerts
//do we need stats - i.e. X number of times triggered, or just the actual alerts themselves?
//perhaps should have rollups of # of times each alert triggered in particular time period, then be able to see 
//all the matching triggers
//if we do this, we could make it a component to potentially show on the reponse detail page
import Selection from './Selection';
import NotFound from '../../components/NotFound';

const Guardrails = () => {
    let {accountKey, appKey} = useParams();

    //console.log('Apps: ' + (new Date()).toLocaleTimeString())
    //can add exact={true} to / as well
    return (
        <Container fluid>
            <LeftNav accountKey={accountKey} appKey={appKey}/>
            <Routes>
                <Route path="/app/:appKey" element={<GuardrailList />} />
                
                <Route path="/app/:appKey/detail/:alertId?" element={<GuardrailDetail />} />
                <Route path="/app/:appKey/add" element={<GuardrailForm />} />
                {/*<Route path="/app/:appKey/alerts/:alertId/:startFactDate?/:endFactDate?" element={<GuardrailLog />} />*/}
                <Route path="/" element={<Selection />} />
                
                <Route path="*" element={<NotFound />} />
            </Routes>

        </Container>
    )
}

export default Guardrails;
